import React from 'react';
import PropTypes from 'prop-types';

const Input = ({
  id, placeHolder, icon, disabled, defaultValue, onChange
}) => (
  <input
    type="text"
    id={id}
    className={icon ? `news-events-input ${icon}` : 'news-events-input'}
    placeholder={placeHolder}
    disabled={disabled}
    defaultValue={defaultValue}
    onChange={onChange}
    autoComplete="false"
    onKeyPress={event => {
        if (event.key === 'Enter') {
            event.preventDefault()
        }
    }}

  />
);

export default Input;

Input.defaultProps = {
  icon: '',
  disabled: false,
  onChange: () => {},
};

Input.propTypes = {
  id: PropTypes.string.isRequired,
  icon: PropTypes.string,
  placeHolder: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};
